<template>
    <div v-if="expanded && hasKnownTotal" class="total-cost" aria-live="polite">
        <div class="total-cost__head">
            <span class="total-cost__label">{{ totalLabel }}</span>
            <strong class="total-cost__value">{{ totalDisplay }}</strong>
        </div>
        <span class="total-cost__note">{{ totalNote }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../eventBus'
import { functions } from '../../functions'
import { SHOW_PRICES } from '../../config'

export default {
    name: 'TotalCost',
    props: ['size', 'centsShow', 'expanded'],
    data() {
        return {
            totalCost: 0,
        }
    },
    computed: {
        ...mapGetters([
            'getTotalCost',
            'allMenuOptions',
        ]),
        showPrices(){
            return SHOW_PRICES
        },
        normalizedTotal(){
            var value = functions.parsePrice(this.totalCost)
            return value === null ? 0 : value
        },
        hasKnownTotal(){
            return this.normalizedTotal > 0
        },
        priceCoverage(){
            var options = this.allMenuOptions || {}
            var selected = []
            Object.keys(options).forEach((key) => {
                var slot = options[key] && options[key].item
                var contents = slot && slot.contents
                if(Array.isArray(contents)){
                    selected = selected.concat(contents.filter(Boolean))
                }
                else if(contents){
                    selected.push(contents)
                }
            })
            var priced = selected.filter((item) => functions.parsePrice(item && item.amzn_price) > 0).length
            return {
                selected: selected.length,
                priced: priced,
                missing: Math.max(0, selected.length - priced),
            }
        },
        totalLabel(){
            if(this.showPrices){
                return this.priceCoverage.missing ? 'Known subtotal' : 'Build total'
            }
            return this.priceCoverage.missing ? 'Estimated subtotal' : 'Estimated total'
        },
        totalDisplay(){
            return this.showPrices
                ? functions.formatUsd(this.normalizedTotal, true)
                : functions.formatTypicalPriceBand(this.normalizedTotal)
        },
        totalNote(){
            var coverage = this.priceCoverage
            if(coverage.missing){
                return coverage.missing + (coverage.missing === 1 ? ' selected part has no catalog price' : ' selected parts have no catalog price')
            }
            return this.showPrices
                ? 'Current catalog prices'
                : 'Estimated from catalog prices ' + functions.typicalPriceVarianceLabel()
        },
    },
    methods: {
        syncTotal(total){
            var parsed = functions.parsePrice(total)
            this.totalCost = parsed === null ? 0 : parsed
        },
    },
    created(){
        this.syncTotal(this.getTotalCost)
    },
    mounted(){
        EventBus.$on('totalCostChanged', this.syncTotal)
    },
    beforeDestroy(){
        EventBus.$off('totalCostChanged', this.syncTotal)
    },
}
</script>

<style scoped>
.total-cost {
    width: 100%;
    padding-top: 0.78rem;
    border-top: 1px solid rgba(67, 72, 87, 0.68);
}
.total-cost__head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.65rem;
}
.total-cost__label {
    color: #9198aa;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
.total-cost__value {
    /* Prices are yellow everywhere in the builder; the total is a price. */
    color: #e4d836;
    font-size: 15px;
    font-variant-numeric: tabular-nums;
    line-height: 1.15;
    text-align: right;
    font-weight: 600;
    white-space: nowrap;
}
.total-cost__note {
    display: block;
    margin-top: 0.24rem;
    color: #697589;
    font-size: 10px;
    line-height: 1.3;
    text-align: right;
}
</style>
